import { createSlice } from "@reduxjs/toolkit";

interface CertificateInterface {
    currentPage?: number;
    searchTerm?: string;
    itemsPerPage?: number;
    itemsPerPageSelect: { value: number; activeValue: boolean }[];
    activeTab?: "active" | "expired";
    isLeftTagModalOpenIndex?: number;
    isRightTagModalOpenIndex?: number;
}

const initialState: CertificateInterface = {
    currentPage: 1,
    searchTerm: "",
    itemsPerPage: 12,
    itemsPerPageSelect: [
        { value: 12, activeValue: true },
        { value: 25, activeValue: false },
        { value: 50, activeValue: false },
    ],
    activeTab: "active",
    isLeftTagModalOpenIndex: -1,
    isRightTagModalOpenIndex: -1,
};

const CertificateSlice = createSlice({
    name: "certificates",
    initialState,
    reducers: {
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
        setSearchTerm: (state, action) => {
            state.searchTerm = action.payload;
        },
        setActiveTab: (state, action) => {
            state.activeTab = action.payload;
        },
        setItemsPerPage: (state, action) => {
            state.itemsPerPage = action.payload;
            state.itemsPerPageSelect = state.itemsPerPageSelect.map((item) => ({
                ...item,
                activeValue: item.value === action.payload,
            }));
        },
        setIsLeftTagModalOpenIndex: (state, action) => {
            state.isLeftTagModalOpenIndex = action.payload;
        },
        setIsRightTagModalOpenIndex: (state, action) => {
            state.isRightTagModalOpenIndex = action.payload;
        },
    },
});

export const certificateReducer = CertificateSlice.reducer;
export const {
    setItemsPerPage,
    setCurrentPage,
    setSearchTerm,
    setActiveTab,
    setIsLeftTagModalOpenIndex,
    setIsRightTagModalOpenIndex,
} = CertificateSlice.actions;
